import React, { useState, useEffect } from "react";
import { withTranslation } from "react-i18next";
import i18next from "i18next";
import axios from "axios";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import { Dialog, Button, TextInput, Image } from "hesus-ui-kit";
import ClipLoader from "react-spinners/ClipLoader";
import {
  useGetGeneralParameters,
  useGetMainCurrencyByCountryId,
  countryCordinatesById,
} from "@hooks/useGeneralParams";
import AddressSearchWithMap from "@components/AddressSearch/AddressSearchWithMap";
import closeIcon from "@icons/ic-close-white.svg";
import { initMap } from "@utils/mapSingleMarkerDragged";
import Trucks from "./components/Trucks/Trucks";
import {
  labelStyles,
  inputStyles,
  labelStylesError,
  inputStylesError,
} from "@utils/extra-style";
import UserInfo from "@utils/UserInfo";
import {
  HeaderWrapper,
  Title,
  ButtonWrapper,
  FormBody,
  SectionContainer,
  OuterWrapper,
  FlexRow,
  GridRow,
  MapContainer,
} from "./AddEditWarehouse.styled";
import "./AddEditWarehouse.scss";

const AddEditWarehouse = (props) => {
  const {
    t,
    id,
    onClose,
    updateRefeshStatus,
    isEditMode,
    companyId,
    carrierId,
    countryId: companyCountryId,
  } = props;

  const generalParams = useGetGeneralParameters();
  const countryInfo = UserInfo.countryInfo();
  const countryId = companyCountryId || countryInfo.country.id;

  const [isWarehouseCreating, setIsWarehouseCreating] = useState(false);
  const [warehouseAPIError, setCreateWarehouseAPIError] = useState("");

  const countries = generalParams?.countryList;
  const mainCurrency = useGetMainCurrencyByCountryId(companyCountryId);
  const [defaultCoordinates, setDefaultCoordinates] = useState(
    countryCordinatesById(countryId) ?? {}
  );
console.log("defaultCoordinates", defaultCoordinates);
  const [isRequired, setIsRequired] = useState([{ requiredStatus: false }]);

  const [inputList, setInputList] = useState([
    {
      id: "",
      status: true,
      transportType: "",
      count: "",
      price: "",
      currency: mainCurrency,
      unit: "",
    },
  ]);

  const [inputListError, setInputListError] = useState([
    {
      transportTypeError: "",
      countError: "",
      priceError: "",
      currencyError: "",
      unitError: "",
    },
  ]);

  const warehouseByIds = useSelector((state) => state.warehouseList.byId);
  const [position, setPosition] = useState();
  const selectedWarehouseById = warehouseByIds[id];

  const selectedwarehouseData = useSelector(
    (state) => state.warehouseList.selectedWarehouse
  );

  const [selectedWarehouse, setSelectedWarehouse] = useState(
    selectedWarehouseById ?? selectedwarehouseData
  );

  const language = countryInfo.country.lang;

  const [formData, setFormData] = useState({
    name: {
      required: false,
      value: selectedWarehouse?.name ?? "",
      error: "",
    },
    phone: {
      required: false,
      value: selectedWarehouse?.phone ?? "",
      error: "",
    },
    address: {
      required: false,
      value: selectedWarehouse?.address ?? "",
      error: "",
    },
    transportTypes: {
      required: true,
      value: "",
      error: "",
    },
  });

  const onAddressSelect = (selectedAddress) => {
    const address = {
      street: selectedAddress.street.value,
      postalCode: selectedAddress.postal.value,
      city: selectedAddress.city.value,
      country: selectedAddress.countryId.value,
      position: {
        latitude: selectedAddress.latitude.value,
        longitude: selectedAddress.longitude.value,
      },
    };
    setFormData({
      ...formData,
      address: {
        value: address,
        error: "",
        required: true,
      },
    });
  };

  const onLatLngUpdate = (lat, lng) => {
    const newPosition = { ...formData.address.value.position };
    newPosition.latitude = lat;
    newPosition.longitude = lng;
    setFormData((formData) => {
      return {
        ...formData,
        address: {
          ...formData.address,
          value: {
            ...formData.address.value,
            position: newPosition,
          },
        },
      };
    });

    setPosition([]);
  };

  const onNameChange = (e) => {
    setFormData({
      ...formData,
      name: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };
  const onPhoneChange = (e) => {
    setFormData({
      ...formData,
      phone: {
        value: e.target.value,
        error: "",
        required: true,
      },
    });
  };

  useEffect(() => {
    if (
      !!defaultCoordinates?.latitude &&
      !!defaultCoordinates?.longitude &&
      !isEditMode
    )
      initMap(
        defaultCoordinates.latitude,
        defaultCoordinates.longitude,
        setPosition
      );
  }, [defaultCoordinates]);

  useEffect(() => {
    if (
      !!formData.address?.value?.position?.latitude &&
      !!formData.address?.value?.position?.longitude
    ) {
      initMap(
        formData.address?.value?.position?.latitude,
        formData.address?.value?.position?.longitude,
        setPosition
      );
    }
  }, [formData.address]);

  const getCountryName = (selectedCountryId) => {
    if (selectedCountryId) {
      const isCountryPresent = countries.find(
        ({ id }) => id === selectedCountryId
      );
      if (isCountryPresent) {
        return isCountryPresent.label;
      }
    }
    return "";
  };

  const validateForm = (data, inputList, inputListError) => {
    let isFormValid = true;
    if (!data.name.value) {
      isFormValid = false;
      data.name.error = t("FIELD_REQUIRED");
    }
    if (!data.phone.value) {
      isFormValid = false;
      data.phone.error = t("FIELD_REQUIRED");
    }
    if (data.phone.value && !/^[0-9+]{8,14}$/i.test(data.phone.value)) {
      isFormValid = false;
      data.phone.error = t("INVALID_FORMAT");
    }
    if (!data.address.value?.postalCode) {
      isFormValid = false;
      data.address.error = t("FIELD_REQUIRED");
    }
    const listError = [...inputListError];
    if (inputList.length > 0 && !isEditMode) {
      if (inputList.length === 1) {
        inputList.map((x, index) => {
          if (
            x.count !== "" ||
            x.price !== "" ||
            x.transportType !== "" ||
            x.unit !== ""
          ) {
            if (x.count === "") {
              isFormValid = false;
              const name = "countError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.transportType === "") {
              isFormValid = false;
              const name = "transportTypeError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.currency === "") {
              isFormValid = false;
              const name = "currencyError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.price === "") {
              isFormValid = false;
              const name = "priceError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.unit === "") {
              isFormValid = false;
              const name = "unitError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
          }
        });
      } else {
        inputList.map((x, index) => {
          if (
            x.count === "" ||
            x.currency === "" ||
            x.price === "" ||
            x.transportType === "" ||
            x.unit === ""
          ) {
            isFormValid = false;

            if (x.count === "") {
              const name = "countError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.transportType === "") {
              const name = "transportTypeError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.currency === "") {
              const name = "currencyError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.price === "") {
              const name = "priceError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
            if (x.unit === "") {
              const name = "unitError";
              listError[index][name] = t("FIELD_REQUIRED");
            }
          }
        });
      }
      setInputListError(listError);
    }
    if (!isFormValid) {
      setFormData({ ...data });
    }
    return isFormValid;
  };

  const getFormData = () => {
    let truckData = [];
    if (inputList.length > 0 && !isEditMode) {
      inputList.map((transport) => {
        if (
          transport.count !== "" &&
          transport.currency !== "" &&
          transport.price !== "" &&
          transport.transportType !== "" &&
          transport.unit !== ""
        ) {
          truckData.push({
            id: null,
            truckType: {
              id: transport?.transportType?.value,
              name: transport?.transportType?.label,
            },
            count: transport.count,
            currency: { id: transport.currency },
            price: transport.price,
            unit: transport.unit,
            status: true,
          });
        }
      });
    }

    if (
      !!isEditMode &&
      !!selectedWarehouse.trucks &&
      selectedWarehouse.trucks.length > 0
    ) {
      selectedWarehouse.trucks.map((transport) => {
        truckData.push({
          id: null,
          truckType: {
            id: transport?.truckType?.id,
            name: transport?.truckType?.name,
          },
          count: transport.count,
          currency: { id: transport.currency.id },
          price: transport.price,
          unit: transport.unit,
          status: true,
        });
      });
    }

    const data = {
      id: isEditMode ? selectedWarehouse.id : "",
      name: formData.name.value,
      phone: formData.phone.value,
      status: true,
      address: {
        address: formData.address.value.street,
        zipcode: formData.address.value.postalCode,
        city: formData.address.value.city,
        country: formData.address.value.country,
        position: {
          latitude: formData.address.value.position.latitude,
          longitude: formData.address.value.position.longitude,
        },
      },
      trucks: truckData,
    };
    return data;
  };

  const onSubmit = () => {
    const isFormValid = validateForm(formData, inputList, inputListError);
    if (isFormValid) {
      setIsWarehouseCreating(true);
      setCreateWarehouseAPIError("");
      if (!id && !isEditMode) {
        axios
          .post(
            `/companies/${companyId}/hauliers/${carrierId}/warehouses`,
            getFormData()
          )
          .then(() => {
            setIsWarehouseCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsWarehouseCreating(false);
            setCreateWarehouseAPIError(error.response?.data?.message ?? "");
          });
      } else {
        axios
          .put(
            `/companies/${companyId}/hauliers/${carrierId}/warehouses/${selectedWarehouse.id}`,
            getFormData()
          )
          .then(() => {
            setIsWarehouseCreating(false);
            updateRefeshStatus();
            onClose();
          })
          .catch((error) => {
            setIsWarehouseCreating(false);
            setCreateWarehouseAPIError(error.response?.data?.message ?? "");
          });
      }
    }
  };

  return (
    <Dialog>
      <div>
        <HeaderWrapper>
          <Title>{t("WAREHOUSE")}</Title>
          <Button
            onClick={onClose}
            styles={{
              backgroundColor: "transparent",
              border: "none",
              height: "auto",
              padding: 0,
              "&:hover": {
                backgroundColor: "transparent",
              },
            }}
          >
            <Image src={closeIcon} alt="close Analytical Note price popup" />
          </Button>
        </HeaderWrapper>
        <FormBody>
          <OuterWrapper>
            <FlexRow>
              <SectionContainer>
                <GridRow column="1fr">
                  <TextInput
                    type="text"
                    label={t("WAREHOUSE_NAME")}
                    name="warehouse-name"
                    id="warehouse-name"
                    isFloat
                    value={String(formData.name.value)}
                    onChange={onNameChange}
                    containerStyles={{ marginTop: "21px" }}
                    labelStyles={
                      formData.name.error !== ""
                        ? labelStylesError
                        : labelStyles
                    }
                    inputStyles={
                      formData.name.error !== ""
                        ? inputStylesError
                        : inputStyles
                    }
                    required
                    error={formData.name.error}
                    placeholder={t("WAREHOUSE_NAME")}
                  />
                </GridRow>
                <GridRow column="1fr 1fr">
                  <TextInput
                    type="text"
                    label={t("WAREHOUSE_PHONE_NUMBER")}
                    name="warehouse-phone"
                    id="warehouse-phone"
                    isFloat
                    value={String(formData.phone.value)}
                    onChange={onPhoneChange}
                    containerStyles={{ marginTop: "21px" }}
                    labelStyles={
                      formData.phone.error !== ""
                        ? labelStylesError
                        : labelStyles
                    }
                    inputStyles={
                      formData.phone.error !== ""
                        ? inputStylesError
                        : inputStyles
                    }
                    required
                    error={formData.phone.error}
                    placeholder={t("WAREHOUSE_PHONE_NUMBER")}
                  />
                </GridRow>
                <GridRow column="1fr">
                  <AddressSearchWithMap
                    isFloat
                    position={position}
                    setPosition={setPosition}
                    title="WAREHOUSE_ADDRESS"
                    countryId={countryId}
                    name={selectedWarehouse?.address ?? "addwarehouse"}
                    language={language}
                    onAddressSelect={onAddressSelect}
                    onLatLngUpdate={onLatLngUpdate}
                    error={formData.address.error}
                    defaultAddress={
                      isEditMode
                        ? formData.address.value?.street +
                          " " +
                          formData.address.value?.postalCode +
                          " " +
                          formData.address.value?.city +
                          " " +
                          (formData.address.value?.country
                            ? getCountryName(formData.address.value.country)
                            : "")
                        : ""
                    }
                  />
                </GridRow>
                <GridRow>
                  <div>
                    {!!defaultCoordinates?.latitude &&
                      !!defaultCoordinates?.longitude && (
                        <MapContainer id="map" />
                      )}
                  </div>
                </GridRow>
                {!isEditMode && (
                  <Trucks
                    inputList={inputList}
                    setInputList={setInputList}
                    inputListError={inputListError}
                    setInputListError={setInputListError}
                    isRequired={isRequired}
                    setIsRequired={setIsRequired}
                    countryId={companyCountryId}
                    mainCurrency={mainCurrency}
                  />
                )}
              </SectionContainer>
            </FlexRow>
          </OuterWrapper>
        </FormBody>
        <ButtonWrapper>
          <Button
            styles={{
              color: "white",
              background: "#1BACE4",
              border: "1px solid #1BACE4",
              marginRight: "0.32rem",
              "&:hover": {
                backgroundColor: "#1589b6",
              },
            }}
            onClick={onSubmit}
          >
            <>
              {isWarehouseCreating && <ClipLoader size={15} color="#fff" />}
              {!isWarehouseCreating && t("SUBMIT")}
            </>
          </Button>
          <Button
            styles={{
              color: "#333",
              background: "#fff",
              border: "1px solid #ccc",
              "&:hover": {
                backgroundColor: "#ccc",
              },
            }}
            onClick={onClose}
          >
            {t("CLOSE")}
          </Button>
        </ButtonWrapper>
      </div>
    </Dialog>
  );
};

AddEditWarehouse.propTypes = {
  t: PropTypes.func.isRequired,
  id: PropTypes.number,
  isEditMode: PropTypes.bool,
};
AddEditWarehouse.defaultProps = {
  isEditMode: false,
  id: null,
};

export default withTranslation()(AddEditWarehouse);
